import * as React from 'react'
import { NavLink } from "react-router-dom";

interface IProps {
    currentPage: number;
    pageSize: number;
}

const PageSize: React.SFC<IProps> = (props) => {
    const pageSizes = [25, 50, 100];
    const { currentPage, pageSize } = props

    return (
        
        <div className="">
            {/* <span id="label">Show:</span> */}
            <ul className="pagination">
                {pageSizes.map(ps => (
                    <li 
                        className={pageSize === ps ? "active" : ""} 
                        key={ps}>
                            <NavLink to={`/report/page/${currentPage}/pageSize/${ps}`}>{ps}</NavLink>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default PageSize



// WEBPACK FOOTER //
// ./src/components/Pager/PageSize.tsx